module.exports = __webpack_public_path__ + "static/media/jakkei-icon.c8374ae5.svg";